import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import ReactGA from 'react-ga';
import { clarity } from 'react-microsoft-clarity';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN || '');
ReactGA.pageview(window.location.pathname + window.location.search);

clarity.init(process.env.REACT_APP_MS_CLARITY_TOKEN || '');

// Extend Window interface for custom environment variables
interface CustomWindow extends Window {
  REACT_APP_LOGO_OVERRIDE: string;
  REACT_APP_PLATFORM_NAME: string;
}

declare let window: CustomWindow;

// Assign environment variables to the window object
window.REACT_APP_LOGO_OVERRIDE = process.env.REACT_APP_LOGO_OVERRIDE || 'defaultLogo.svg';
window.REACT_APP_PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME || 'Devices for Education';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
